//scroll variable to track window's scroll
var lastScrollTop = 0;
var mobileW = 0;

//vanilla variables for resizing 
var w=window,
d=document,
e=d.documentElement,
g=d.getElementsByTagName('body')[0],
windowWidth = w.innerWidth||e.clientWidth||g.clientWidth,
windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

//header image to be window height on homepage
if(document.getElementsByClassName('img-slide').length > 0){
	let headerImages = document.getElementsByClassName('img-slide');
	let headerImagesLength = headerImages.length;
	for(let i = 0; i < headerImagesLength; i++){
		headerImages[i].style.height = (windowHeight + 10) + 'px';
	}
}
resizeWindow();


// Func = limiting Scope for this file
(function(){
	
	window.onload = function() {
		resizeWindow();
		scrollW();
	};

	window.addEventListener('scroll', function(){
		scrollW();
	})
	window.addEventListener('resize', function(){
		resizeWindow();
	});

	//Api weather
	if (location.pathname == "/") {
		weather();
	}

	//mobile burger menu
	document.getElementById('burgerMenu').addEventListener('click', function(){
		if(!this.classList.contains('open')){
			this.parentElement.classList.add('open');
			this.classList.add('open');
			document.getElementById('primary-nav').classList.add('open');
			document.getElementById('js-text').innerHTML = "Close";
	
		} else {
			this.classList.remove('open');
			this.parentElement.classList.remove('open');
			document.getElementById('primary-nav').classList.remove('open');
			document.getElementById('js-text').innerHTML = "Menu";
		
		}
	});
}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;

		if(st > 80){
			if (st > lastScrollTop){
				// downscroll code
				if(!document.getElementById('header').classList.contains('internal')){
					document.getElementById('header').classList.add('internal')
				}
			} 
		} else {
				document.getElementById('header').classList.remove('internal');
		}
	
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
function resizeWindow(){
	//calculate a new window size
	windowWidth = w.innerWidth||e.clientWidth||g.clientWidth;
	windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

	//header image to be window height on homepage
	if(document.getElementsByClassName('img-slide').length > 0){
		let headerImages = document.getElementsByClassName('img-slide');
		let headerImagesLength = headerImages.length;
		for(let i = 0; i < headerImagesLength; i++){
			headerImages[i].style.height = (windowHeight + 10) + 'px';
		}
	}
	
	
}

function weather(){
	let state = 'Clayton'
	let weather_grades = document.getElementById('temp-js');
    let weather_speed = document.getElementById('speed-js');
    let weather_humidity = document.getElementById('humidity-js');
    let weather_description = document.getElementById('description-js');
	fetch(`https://api.openweathermap.org/data/2.5/weather?q=${state},us&APPID=0ddd1af8b5b1833cedd6da7a90934cce&units=imperial`)
	.then(function (response) {
		return response.json();
	})
	.then(function (myJson) {
        
        weather_grades.innerHTML =  parseInt(myJson.main.temp) + '°F';
        weather_speed.innerHTML =  parseInt(myJson.wind.speed) + 'MPH';
        weather_humidity.innerHTML =  parseInt(myJson.main.humidity) + '%';
        weather_description.innerHTML =  myJson.weather[0].description ;
	})
}

//window offset
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}